angular.module('leanlaw').directive('llInvoiceLineItem', ['$state', 'printPreview', function ($state, printPreview) {
  return {
    restrict: 'EA',
    scope: {
      lineItem: '=',
      groupIndex: '=',
      itemIndex: '=',
      entry: '=',
      edit: '&',
      ledes: '=',
      customFlag: '='
    },
    template: require('./views/invoiceLineItem.html'),
    controller: ['$scope', function ($scope) {
      $scope.print = printPreview;
      $scope.format = $scope.$parent.format;
      $scope.state = $scope.$parent.state;
      $scope.item = $scope.lineItem || $scope.entry;
      $scope.edit = function (focus) {
        // if ($scope.item.expense) {
        //     var expense = $scope.item.expenses[0];
        //     return $state.go('.expense', { expenseId: expense.id });
        // }
        $state.go('.item', {
          groupIndex: $scope.groupIndex,
          itemIndex: $scope.itemIndex,
          focus,
          ledes: $scope.ledes
        });
      };
    }]
  };
}]);